/**
 * The look of a gallery background: its brightness and its opacity, in
 * percent, as the sidebar sliders set them.
 *
 * Each background of a page has its own look. A default save writes it to the
 * row of the background on screen (layout/DefaultScenePanel/lookRowTarget.ts).
 * A background whose default gives no look shows the neutral look, not the
 * look of the background before it: a save on that background would otherwise
 * write the look of the other background to its row.
 */

export const BG_LOOK_FIELDS = ["bgBrightness", "bgOpacity"] as const;

export type BgLookField = (typeof BG_LOOK_FIELDS)[number];

export type BgLook = Record<BgLookField, number>;

/** The look when nothing sets one: the initial state of contexts/images. */
export const NEUTRAL_BG_LOOK: Readonly<BgLook> = Object.freeze({bgBrightness: 100, bgOpacity: 100});

/** The look a default scene gives; the neutral value for a field it does not set. */
export function defaultBgLook(
  scene: Partial<Record<BgLookField, unknown>> | null | undefined
): BgLook {
  const look = {...NEUTRAL_BG_LOOK};
  for (const field of BG_LOOK_FIELDS) {
    const value = scene?.[field];
    if (typeof value === "number") look[field] = value;
  }
  return look;
}
